<template>
  <div>
    <div class="form-group">
     <label>{{__('forms.PeopleRoles.responsible')}}</label>
      <select class="form-control" name="peopleRole[responsible_person_id]"  v-model="person_role.responsible_person_id" @change="getRoles()">
          <option v-for="person in people" :value="person.id" v-bind:key="person.id">
            {{person.fullName}}
          </option>
      </select>
    </div>
    <div class="form-group">
      <label>{{__('forms.PeopleRoles.responsible_role')}}</label>
      <select class="form-control" name="peopleRole[responsible_role_id]" v-model="person_role.responsible_role_id">
        <option v-for="role in roles" :value="role.id" v-bind:key="role.id">
          {{role.name}}
        </option>
      </select>
    </div>

  </div>
</template>

<script>
export default {
  data () {
    return {
        roles: {},
    }
  },
  methods: {
    getRoles() {

      axios.get("/people-roles-get-roles-by-people/"+this.person_role.responsible_person_id+"/person?external_role_id="+this.person_role.responsible_role_id)
          .then((response) => {            
            this.roles = response.data;
          });
    }
  },
  mounted() {    
      this.getRoles();
  },
  props: {
    people: {
      type: Array,
      required: true
    },
    person_role : {
      type : Object,
      required : true
    },
  }
}
</script>